import { useMemo } from 'react';

import { useJsonField } from '../../hooks/useJsonField';

/**
 * Custom hook to parse and manage base query fields from GraphQL
 * Reduces boilerplate for handling JSON string fields
 */
export const useBaseQueryField = (fieldValue: string | null | undefined) => {
  const parsed = useMemo(() => {
    if (!fieldValue || fieldValue.trim() === '') {
      return null;
    }
    try {
      return JSON.parse(fieldValue) as Record<string, unknown>;
    } catch {
      return null;
    }
  }, [fieldValue]);

  return useJsonField(parsed);
};
